import { Dayjs } from "dayjs";

export function disableCalendarDate(
  everyDay: Dayjs,
  minDate?: Dayjs,
  maxDate?: Dayjs
): boolean {
  return isDateDisable(everyDay, minDate, maxDate);
}

export function isDateDisable(
  everyDay: Dayjs,
  minDate?: Dayjs,
  maxDate?: Dayjs
): boolean {
  let isDateBeforeMinDate = true;
  let isDateAfterMaxDate = true;

  isDateBeforeMinDate = minDate ? everyDay.isBefore(minDate): false;
  isDateAfterMaxDate = maxDate ? everyDay.isAfter(maxDate) : false;
  return isDateBeforeMinDate || isDateAfterMaxDate;
}
export function isSpring(
  date: Dayjs,
  minSpring: Dayjs,
  maxSpring: Dayjs
): boolean {
  
  let isDateAfterMinSpring = true;
  let isDateBeforMaxSpring = true;
  
  isDateAfterMinSpring = date.isAfter(minSpring);
  isDateBeforMaxSpring =  date.isBefore(maxSpring);

  return isDateAfterMinSpring && isDateBeforMaxSpring;
}